import { VOLUME_UNITS } from "../pages/admin-details/account/constants";

export const convertGallonsTo = (to: VOLUME_UNITS, gallons: number) => {
  switch (to) {
    case VOLUME_UNITS.GALLONS:
      return gallons;
    case VOLUME_UNITS.LITERS:
      return gallons * 3.78541;
    case VOLUME_UNITS.IMPERIAL_GALLONS:
      return gallons * 0.832674;
    case VOLUME_UNITS.FT_3:
      return gallons * 0.133681;
    default:
      return gallons;
  }
};

export const accountVolumeUnit = (unit: VOLUME_UNITS) => {
  switch (unit) {
    case VOLUME_UNITS.GALLONS:
      return "gal";
    case VOLUME_UNITS.LITERS:
      return "L";
    case VOLUME_UNITS.IMPERIAL_GALLONS:
      return "igal";
    case VOLUME_UNITS.FT_3:
      return "ft³";
    default:
      return "gal";
  }
};
export const convertLitersTo = (to: VOLUME_UNITS, liters: number) => {
  switch (to) {
    case VOLUME_UNITS.LITERS:
      return liters;
    case VOLUME_UNITS.GALLONS:
      return liters / 3.78541;
    case VOLUME_UNITS.IMPERIAL_GALLONS:
      return liters / 4.54609;
    case VOLUME_UNITS.FT_3:
      return liters / 28.3168;
    default:
      return liters;
  }
};
export const convertToLitersForApi = (
  from: VOLUME_UNITS,
  value: number
): number => {
  switch (from) {
    case VOLUME_UNITS.LITERS:
      return value;
    case VOLUME_UNITS.GALLONS:
      return value * 3.78541;
    case VOLUME_UNITS.IMPERIAL_GALLONS:
      return value * 4.54609;
    case VOLUME_UNITS.FT_3:
      return value * 28.3168;
    default:
      return value;
  }
};
